import { single as inner } from "./Manager";

import _ from 'underscore';
import zepto  from 'zepto-webpack';

var _outer = {};

inner.onMemberJoin = function (member, confrId){
    emedia.decodeMemeberName(member);
    this.onMemberJoined(member, inner._confr(confrId));
};
inner.onMemberLeave = function (member, reason, confrId){
    emedia.decodeMemeberName(member);
    this.onMemberExited(member, reason, inner._confr(confrId));
};
inner._onRoleUpdated = function (role, confrId){
    this.onRoleChanged(role, inner._confr(confrId));
};
inner._onAddMemberStream = function (stream, confrId){
    stream && emedia.decodeMemeberName(stream.owner);
    this.onStreamAdded(stream.owner, stream, inner._confr(confrId));
};
inner._onRemoveMemberStream = function (stream, confrId){
    stream && emedia.decodeMemeberName(stream.owner);
    this.onStreamRemoved(stream.owner, stream, inner._confr(confrId));
};
inner._onUpdateMemberStream = function(stream, constaints, confrId){
    stream && emedia.decodeMemeberName(stream.owner);
    this.onStreamUpdated && this.onStreamUpdated(stream.owner, stream, constaints, inner._confr(confrId));
};
inner.onExit = function(reason, failed, confrId){
    this.onConferenceExit(reason, failed, inner._confr(confrId));
};

/**
 * 有人加入会议的回调 返回member
 * @method onMemberJoined
 */
_outer.onMemberJoined = function (member) {

};
/**
 * 有人退出的回调 返回member，reason
 * @method onMemberExited
 */
_outer.onMemberExited = function (member, reason) {

};
/**
 * 改变角色的回调 返回role
 * @method onRoleChanged
 */
_outer.onRoleChanged = function (role) {

};
/**
 * 有媒体流加入的回调 返回role
 * @method onStreamAdded
 */
_outer.onStreamAdded = function (member, stream) {

};
/**
 * 有媒体流移除的回调 返回role
 * @method onStreamRemoved
 */
_outer.onStreamRemoved = function (member, stream) {

};
/**
 * 退出会议的回调 返回role
 * @method onConferenceExit
 */
_outer.onConferenceExit = function (reason, error) {

};

/**
 * 通过ticket加入会议
 * @method joinConferenceWithTicket
 * @param {String} confrId - 会议id
 * @param {String} ticket - 会议ticket
 * @param {String} ext - 扩展
 */
_outer.joinConferenceWithTicket = inner.joinUseTicket;

/**
 * 通过password加入会议
 * @method joinConference
 * @param {String} confrId - 会议id
 * @param {String} password - 会议密码
 * @param {String} ext - 扩展
 */
_outer.joinConference = inner.joinUsePassword;

/**
 * 获取会议ticket
 * @method getConferenceTkt
 * @param {String} confrId - 会议id
 * @param {String} password - 会议密码
 */
_outer.getConferenceTkt = inner.reqTkt;

/**
 * 发布媒体流
 * @method publish
 * @param {Object} constaints - 
 * @param {boolean} audio - 是否发布音频
 * @param {boolean} video - 是否发布视频
 * @param {Object} videoTag - video标签
 * @param {string} ext - 扩展
 */
_outer.publish = function (constaints, videoTag, ext) {
    return inner.shareVideoWithAudio(constaints.video, constaints.audio, videoTag, ext);
};

/**
 * 取消发布媒体流
 * @method unpublish
 * @param {Object} constaints - 
 * @param {boolean} audio - 是否发布音频
 * @param {boolean} video - 是否发布视频
 * @param {Object} videoTag - video标签
 * @param {string} ext - 扩展
 */
_outer.unpublish = function (stream) {
    return inner.hungup(stream);
};
//_outer.subscribe = inner.subscribe; //subscribe: function (member, stream, subSVideo, subSAudio, videoTag, confrId)

/**
 * 取消订阅媒体流
 * @method unsubscribe
 * @param {Object} stream - 媒体流
 */
_outer.unsubscribe = function (stream) {
    return inner.hungup(stream);
};

/**
 * 退出会议
 * @method exitConference
 * @param {boolean} closedSelfConfr - 是否关闭创建的会议，默认false
 */
_outer.exitConference = function (closedSelfConfr) {
    return inner.exit(closedSelfConfr || false);
};

/**
 * 获取会议信息
 * @method getConferenceInfo
 * @param {string} confrId - 会议id
 * @param {string} password - 会议密码
 */
_outer.getConferenceInfo = function (confrId, password) {
    return inner.selectConfr(confrId, password);
};

/**
 * 创建会议
 * @method createConference
 * @param {Number} confrType - 会议类型 COMMUNICATION: 10, COMMUNICATION_MIX: 11, LIVE: 12, P2P: 13, INTERCOMM: 14
 * @param {string} password - 会议密码
 * @param {boolean} rec - 是否录制
 * @param {boolean} recMerge - 是否合并
 * @param {boolean} supportWechatMiniProgram - 是否支持小程序
 * @example createConference(emedia.mgr.ConfrType.COMMUNICATION_MIX, pwd, rec, recMerge, suportMiniProgarm)
 */
_outer.createConference = inner.createConfrSptMnPrg;

/**
 * 改变角色
 * @method grantRole
 * @param {Object} confr - 会议对象
 * @param {Array} members - 会议成员
 * @param {string} role - 角色
 */
_outer.grantRole = function (confr, members, role) {
    // emedia.decodeMemeberName(members); 暂时注释，在 IM 一起的时候，appkey 会被删掉
    return inner.chanageRoles(role, members, confr.id);
};

/**
 * 降级角色 -- 只能降级
 * @method degradeRole
 * @param {string} confrId - 会议id
 * @param {Array} members - 会议成员
 * @param {string} role - 角色
 */
_outer.degradeRole = function(confrId, members, toRole) {
    if(!confrId) {
        return
    }
    if(
        !members ||
        members instanceof Array == false ||
        members.length == 0
    ) {
        console.warn('members is must Array also length > 0');
        return
    }

    if(!toRole){
        return
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        console.warn('confr is not exist');
        return
    }
    let { role:oldRole, roleToken } = confr;

    if(Number(toRole) >= Number(oldRole)){ //只能降级操作
        console.warn('only degradeRole,oldRole: ' + oldRole + ' >>> toRole: '+ toRole);
        return
    }

    let params = {
        type:'POST',
        url: emedia.config.restPrefix + '/easemob/rtc/role/degrade',
        data: JSON.stringify({
            roleToken,
            uids:members,
            role:toRole
        }),
        contentType: 'application/json',
    }
    return new Promise((resolve, reject) => {
        $.ajax({
            ...params,
            success(data) {
                if(data.error == 0){
                    resolve(data)
                } else {
                    reject(data)
                }
                
            },
            error(error) {
                reject(error)
            }
        })
    })
}
/**
 * 通过id踢出成员
 * @method kickMembersById
 * @param {Object} confr - 会议对象
 * @param {Array} members - 会议成员
 */
_outer.kickMembersById = function (confr, members) {
    // emedia.decodeMemeberName(members); 暂时注释，在 IM 一起的时候，appkey 会被删掉
    return inner.kickMember(members, confr.id);
};

/**
 * 销毁会议
 * @method destroyConference
 * @param {Object} confr - 会议对象
 */
_outer.destroyConference = function (confr) {
    return inner.disbandConfr(confr, confr.roleToken);
};
// setConference and deleteConference
function _update_confr_attrs(options) {
    if(
        !options || 
        Object.keys(options).length == 0
    ){
        console.warn('options is not have')
        return
    }
    if(!options.key){
        console.warn('options.key is not have')
        return
    }

    let {
        key,
        val,
        success,
        error,
        type
    } = options;

    if(!this.__current_confrId) {
        console.warn('please set_confr_attrs after joined')
        return
    }
    let { roleToken } = this._confrs[this.__current_confrId];

    
    if(!roleToken) {
        console.warn('roleToken is not have')
        return
    }
    

    let data = {
        roleToken,
        cattrs: [{
            key,
            val,
            op: type
        }],
    };
    
    $.ajax({
        type:'POST',
        url: emedia.config.restPrefix + '/easemob/rtc/confr/attrs/update',
        data: JSON.stringify(data),
        contentType: 'application/json',
        success(data) {
            if(success && typeof success == 'function'){
                success(data)
            }
        },
        error(err) {
            if(error && typeof error == 'function'){
                error(err)
            } 
        }
    })
}

/**
 * 设置会议属性
 * @method setConferenceAttrs
 * @param {Object} option
 * @param {string} option.key - 自定义属性
 * @param {string} option.val - 自定义属性值
 * @param {function} option.success - 设置成功的回调
 * @param {function} option.error - 设置失败的回调
 */
_outer.setConferenceAttrs = function(options) {
    options.type = 'UPDATE';

    _update_confr_attrs.call(this, options)
}

/**
 * 删除会议属性
 * @method deleteConferenceAttrs
 * @param {Object} option
 * @param {string} option.key - 自定义属性
 * @param {string} option.val - 自定义属性值
 * @param {function} option.success - 删除成功的回调
 * @param {function} option.error - 删除失败的回调
 */
_outer.deleteConferenceAttrs = function(options) {
    options.type = 'DEL';

    _update_confr_attrs.call(this, options)
}
/**
 * 会议状态回调函数
 * @method onConfrStateUpdated
 * @param {Object} confr_state - 会议状态集合
 */
_outer.onConfrStateUpdated = function(confr_state) {

    // 全体静音、全体解除静音功能
    let _this = this;
    const mute_all_action = () => {
        let { muteAll } = confr_state;

        
        if(muteAll === undefined){
            return
        }

        // 没有改变 return
        if(_this._temp_muteAll === undefined){// 没执行过 赋值
            _this._temp_muteAll = muteAll
        }else {

            if(muteAll === _this._temp_muteAll) {
                return
            }else{
                _this._temp_muteAll = muteAll
            }
        }

        if(muteAll) {
            if(
                _this.onMuteAll &&
                typeof _this.onMuteAll == 'function'
            ) {
                _this.onMuteAll()
            }
        } else {
            if(
                _this.onUnMuteAll &&
                typeof _this.onUnMuteAll == 'function'
            ) {
                _this.onUnMuteAll()
            }
        }
    }

    // 主持人不被执行 全体静音和非全体静音
    let confrId = this.__current_confrId;
    if(!confrId) {
        return
    }

    let service = this._services[confrId];
    if(!service) {
        return
    }

    let { current } = service;
    if(!current) {
        return
    }


    if(current.role && current.role != this.Role.ADMIN){ //不是主持人 执行全体静音回调
        mute_all_action();
    }

} 
/**
 * 创建房间并加入
 * step 1. 创建房间
 * step 2. 获取ticket
 * step 3. joinConfrence
 * */ 

 /**
 * 创建房间并加入
 * @method joinRoom
 * @param {Object} option
 * @param {string} option.roomName - 房间名称
 * @param {string} option.password - 房间密码
 * @param {string} option.role - 进入房间时的角色
 * @param {Object} option.config - 进入房间时的拓展配置 rec: 是否录制；recMerge:是否合并；supportWechatMiniProgram：是否支持小程序
 */
_outer.joinRoom = async function(options){
    
    // 请求 room 接口
    const create = create_params => {
        let { restPrefix, appkey } = emedia.config;

        if(!appkey) {
            throw new Error('in joinRoom appkey is not defined');
        }
        let org_name = appkey.split('#')[0];
        let app_name = appkey.split('#')[1];

        let url = `${restPrefix}/${org_name}/${app_name}/conferences/room`;
        return new Promise((resolve, reject) => {
            let ajax_options = {
                url,
                data:JSON.stringify(create_params),
                type:'POST',
                contentType: 'application/json',
                success: result => {
                    if(!result.error){
                        resolve(result)
                    }else{
                        reject(result)
                    }
                },
                error: error => {
                    reject(error)
                }
            }
            $.ajax(ajax_options)
        })
    }

    let _this = this;
    // get_ticket  加入会议之前获取 ticket
    const get_ticket = get_ticket_params => {

        let url = emedia.config.restPrefix + "/easemob/rtc/req/ticket" + "?_ct=" + (new Date().getTime());
        if(get_ticket_params.region) {
            url += `&REGION=${get_ticket_params.region}`
        }
        if(get_ticket_params.confrId) {
            url += `&CONFRID=${get_ticket_params.confrId}`
        }

        let params = {
            type: 'POST',
            url,
            data: JSON.stringify(get_ticket_params),
            contentType: 'application/json',
            dataType: 'json',
        }

        return new Promise((resolve, reject) => {
            $.ajax({
                ...params,
                success(data) {
                    if(data.error == 0){
                        resolve(data)
                    } else {
                        reject(data)
                    }
                    
                },
                error(error) {
                    reject(error)
                }
            })
        })
    }

    // 加入房间的参数
    let {
        roomName,
        password,
        role,
        config
    } = options

    let {
        identityName: memName,
        identityToken: token
    } = this;


    if(!roomName){
        throw new Error('the roomName is required at joinRoom')
    }
    if(!password){
        throw new Error('the password is required at joinRoom')
    }
    if(!memName){
        throw new Error('the memName is required at joinRoom')
    }
    if(!token){
        throw new Error('the token is required at joinRoom')
    }
    if(!role){
        throw new Error('the role is required at joinRoom')
    } 
    

    let create_params = {
        roomName,
        password,
        memName,
        token,
        ...config
    }
    if (config && config.supportWechatMiniProgram) {
        create_params.useVCodes = ['H264', 'VP8'];
    }

    const room = await create(create_params); // 加入房间

    let { confrId } = room;

    let get_ticket_params = {
        uid: memName,
        token,
        confrId,
        password: password,
        role: role,
        terminal: this._terminalInfo
    }

    let ticket_info = await get_ticket(get_ticket_params); // 获取ticket


    // 给会议添加 参数
    ticket_info.mixed = ticket_info.type === 11 || ticket_info.type === 12;
    ticket_info.id = ticket_info.serverConfrId = ticket_info.confrId = confrId;
    this._confrs[confrId] = Object.assign(this._confrs[confrId] || {}, ticket_info);


    let { ticket } = ticket_info;
    
    let { nickName, ext } = config ? config : {};
    // join confrence 通过 ticket 接口
    let {isCreator} = room;
    let user_room = await _this.joinConferenceWithTicket(confrId, ticket, { nickName, ...ext });

    if(isCreator){// 是否为创建者
        user_room.isCreator = isCreator
    }

    return user_room
}

/**
 * 观众申请上麦
 */

_outer.requestToTalker = function(confrId) {

    if(!confrId) {
        console.warn('requestToTalker confrId is required');
        return
    }

    let service = this._services[confrId];
    service.requestToTalker()
}

/**
 * 申请主持人
 */

_outer.requestToAdmin = function(confrId) {

    if(!confrId) {
        console.warn('requestToTalker confrId is required');
        return
    }

    let service = this._services[confrId];
    service.requestToAdmin()
}

/**
 * 指定静音通过 memberId
 */
_outer.muteBymemberId = function(confrId, memberId) {
    if(
        !confrId ||
        !memberId
    ) {
        console.warn('muteBymemberId confrId and memberId is required');
        return
    }

    let service = this._services[confrId];
    service.muteBymemberId(memberId)

}

/**
 * 指定取消静音通过 memberId
 */
_outer.unmuteBymemberId = function(confrId, memberId) {
    if(
        !confrId ||
        !memberId
    ) {
        console.warn('muteBymemberId confrId and memberId is required');
        return
    }

    let service = this._services[confrId];
    service.unmuteBymemberId(memberId)

}
// 更新会议状态 接口
function _update_confr_state(roleToken,muteAll) {
    // muteAll: true 全体静音，false:取消全体静音
    let params = {
        type:'POST',
        url: emedia.config.restPrefix + '/easemob/rtc/confr/attrs/update',
        data: JSON.stringify({
            roleToken,
            cstate: {
                muteAll
            }
        }),
        contentType: 'application/json',
    };

    return new Promise((resolve, reject) => {
        $.ajax({
            ...params,
            success(data) {
                if(data.error == 0){
                    resolve(data)
                } else {
                    reject(data)
                }
                
            },
            error(error) {
                reject(error)
            }
        })
    }) 
}

// 全体静音
_outer.muteAll = function(confrId) {
    
    if(!confrId) {
        throw new Error('muteAll confrId is required');
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        throw new Error('confr is not exist');
    }
    let { role, roleToken } = confr;
    
    if(role != 7) { //只有管理员能够操作
        throw new Error('only admin can action');
    }
    if(!roleToken) {
        throw new Error('roleToken is not exist');
    }

    let muteAll = true;
    return _update_confr_state.call(this,roleToken,muteAll);

}
// 取消全体静音
_outer.unmuteAll = function(confrId) {
    if(!confrId) {
        throw new Error('unmuteAll confrId is required');
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        throw new Error('confr is not exist');
    }
    let { role, roleToken } = confr;
    
    if(role != 7) { //只有管理员能够操作
        throw new Error('only admin can action');
    }
    if(!roleToken) {
        throw new Error('roleToken is not exist');
    }

    let muteAll = false;
    return _update_confr_state.call(this,roleToken,muteAll);
}
// 多路推流 
_outer.addLive = function(confrId, liveCfg) {
    if(!confrId){
        throw new Error('addLive confrId is required');
    }
    if(!liveCfg){
        throw new Error('addLive liveCfg is required');
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        throw new Error('confr is not exist');
    }
    let { role, roleToken } = confr;
    
    if(role !=7 ){
        throw new Error('only admin can addLive');
    }
    if(!roleToken){
        throw new Error('addLive roleToken is required');
    }

    let url = emedia.config.restPrefix + '/easemob/rtc/livecfg';
    let params = {
        confrId,
        roleToken,
        liveCfg
    }

    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: 'POST',
            data: JSON.stringify(params),
            contentType: 'application/json',
            dataType: 'json',
            success: function(data){
                if(data.error == 0) {
                    resolve(data)
                } else {
                    reject(data)
                }
            },
            error: function(error){
                reject(error)
            }
        });
    })

}
// 推流 CDN 更新布局
_outer.updateLiveLayout = function(confrId, liveId, regions){
    if(!confrId){
        throw new Error('updateLiveLayout confrId is required');
    }
    if(!liveId){
        throw new Error('updateLiveLayout liveId is required');
    }

    if(!regions){
        throw new Error('updateLiveLayout regions is required');
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        throw new Error('confr is not exist');
    }
    let { role, roleToken } = confr;

    if(role !=7 ){
        throw new Error('only admin can updateLiveLayout');
    }
    if(!roleToken){
        throw new Error('updateLiveLayout roleToken is required');
    }

    let url = emedia.config.restPrefix + '/easemob/rtc/live/layout';
    
    let params = {
        confrId, 
        liveId,
        regions,
        roleToken
    }

    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type: 'POST',
            data: JSON.stringify(params),
            contentType: 'application/json',
            dataType: 'json',
            success: function(data){
                if(data.error == 0) {
                    resolve(data)
                } else {
                    reject(data)
                }
            },
            error: function(error){
                reject(error)
            }
        });
    })
}

// 取消推流 CDN
_outer.deleteLive = function (confrId, liveId) {
    if(!confrId) {
        throw new Error('deleteLive confrId is required');
    }
    if(!liveId) {
        throw new Error('deleteLive liveId is required');
    }

    let confr = this._confrs[confrId];

    if(!confr) {
        throw new Error('confr is not exist');
    }
    let { role, roleToken } = confr;

    if(role != 7) {
        console.warn('only admin can deleteLive');
        return
    }
    if(!roleToken){
        console.error('updateLiveLayout roleToken is required');
        return
    }
    
    let url = emedia.config.restPrefix + '/easemob/rtc/delete/live';
    let params = { confrId, liveId, roleToken }

    return new Promise((resolve,reject) => {
        $.ajax({
            url,
            type:'DELETE',
            data: JSON.stringify(params),
            contentType: 'application/json',
            dataType: 'json',
            success: function(data){
                if(data.error == 0) {
                    resolve(data)
                } else {
                    reject(data)
                }
            },
            error: function(error){
                reject(error)
            }
        })
    })
}

emedia.decodeMemeberName = function (member) {
    if(typeof emedia.decodeMemeberNameString !== "function"){
        return member;
    }

    if(typeof member === 'string'){
        return emedia.decodeMemeberNameString(member);
    }

    if(_.isArray(member)){
        for(var i = 0; i < member.length; i++){
            member[i] = emedia.decodeMemeberName(member[i]);
        }
        return member;
    }

    if(member.name){
        member.globalName = member.name;
        member.memName = member.name = emedia.decodeMemeberName(member.name);
        return;
    }

    if(member.memName){
        member.globalName = member.memName;
        member.memName = member.name = emedia.decodeMemeberName(member.memName);
        return;
    }
}


/**
 * 会议类型
 * @static
 */
emedia.ConfrType = inner.ConfrType;

/**
 * 角色
 * @static
 */
emedia.Role = inner.Role;

/**
 * 媒体流类型
 * @static
 */
emedia.StreamType = inner.StreamType;

zepto(function () {
    var WebIM = window.WebIM;

    if(WebIM && WebIM.conn && typeof WebIM.conn.onOpened === "function"){
        // noinspection JSAnnotator
        function useIM() {
            emedia.decodeMemeberNameString = function (member) {
                if(typeof member === 'string'){
                    if(member.indexOf(WebIM.conn.orgName) < 0) {
                        return member;
                    }

                    var _index = member.indexOf("_");
                    if(_index < 0){
                        _index = 0;
                    }else{
                        _index++;
                    }

                    var endIndex = member.indexOf("@");
                    if(endIndex < 0){
                        endIndex = member.length;
                    }

                    return member.substring(_index, endIndex);
                }

                return member;
            };

            inner.setUrlCreator(function(url, apiName){
                return WebIM.conn.apiUrl + url;
            });

            inner.setIdentity(WebIM.conn.orgName + "#" + WebIM.conn.appName + "_" + WebIM.conn.user, WebIM.conn.token);
            emedia.config({ appkey: WebIM.conn.appKey })
        }

        var _onOpened = WebIM.conn.onOpened;
        WebIM.conn.onOpened = function () {
            _onOpened.apply(WebIM.conn, arguments);
            useIM();
        };

        if(WebIM.conn.token){
            useIM();
        };
    }
});


export let outer = _.extend(inner, _outer);